import logo from './logo.svg';
import './App.css';
import PdksMobileWeb from "./PdksMobileWeb";

function App() {
  return (
    <div className="App">
        <PdksMobileWeb></PdksMobileWeb>
    </div>
  );
}

export default App;
